export enum ReturnItemTypes {
  FORM = '1',
  PDF_ATTACHMENT = '2',
}
